module.exports = __webpack_public_path__ + "img/wave.ed617e62.png";